import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { GET_USER_AND_PROFESSIONS_QUERY } from "../../queries/queries";
import { UPDATE_USER } from "../../queries/mutations";
import { CHANGE_PASSWORD } from "../../queries/mutations";
import { DELETE_USER } from "../../queries/mutations";
import Loading from "../loading";
import Error from "../error";
import trashIcon from "../../assets/images/trash.png"
import DeleteModal from "./DeleteModal";
import ModalPortal from "components/shared/modal-portal";
import backArrow from '../../assets/images/left_arrow.png';

const ProfileEdit = ({ handleLogOut }) => {
  let history = useHistory();

  const [id, setId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [professionId, setProfessionId] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [open, setOpen] = React.useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const handleClose = (value) => {
    setOpen(false);
  };

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;

    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });

  const { loading, error, data } = useQuery(GET_USER_AND_PROFESSIONS_QUERY, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      const professionId =
        data.currentUser.profession && data.currentUser.profession.id;
      setId(data.currentUser.id);
      setFirstName(data.currentUser.firstName);
      setLastName(data.currentUser.lastName);
      setEmail(data.currentUser.email);
      setProfessionId(professionId);
    },
  });

  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted(data) {
      setErrorMessage(null);
      setSuccessMessage("Erfolgreich gespeichert");
      history.push(`/profile`);
    },
    onError: (data) => {
      setSuccessMessage(null);
      setErrorMessage(data.graphQLErrors[0].message);
    },
  });

  const [deleteUser] = useMutation(DELETE_USER, {
    onCompleted(data) {
      localStorage.clear();
      // TODO: Delete the user's device token from the backend (deleteDeviceToken mutation)
      setShowDelete(false);
      history.push(`/registration`);
    },
  });

  const onDeleteUser = () => {
    console.log("click");
    setShowDelete(true);
  };

  let passwordResetUrl = "https://apocampus.herokuapp.com/password_resets/new";
  let baseUrl = window.location.origin;
  if (baseUrl.includes("localhost") || baseUrl.includes("apocampus-staging")) {
    passwordResetUrl =
      "https://apocampus-staging.herokuapp.com/password_resets/new";
  }

  const [changePassword] = useMutation(CHANGE_PASSWORD, {
    onCompleted(data) {
      setOpen(true);
    },
    onError: (data) => {
      setSuccessMessage(null);
      setErrorMessage("Leider ist ein Fehler aufgetreten");
    },
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const handleSubmit = () => {
    updateUser({
      variables: {
        id,
        firstName,
        lastName,
        email,
        professionId,
      },
    });
  };

  const handleBack = () => {
    history.goBack() 
  };

  return (
    <>
      <div className="scrollable">
        <div className="profile-edit">
          <img 
            src={backArrow} 
            alt="back" 
            className="points-header-arrow" 
            onClick={handleBack} 
          />
          <div className="profile-data-edit">
            <div className="profile-data-title">Persönliche Daten</div>
            <div className="profile-data-items">
              <input 
                value={data.currentUser.firstName} 
                placeholder="Vorname"
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input 
                value={data.currentUser.lastName} 
                placeholder="Nachname"
                onChange={(e) => setLastName(e.target.value)}
              />
              <select 
                value={professionId || ""} 
                onChange={(e) => setProfessionId(e.target.value)}
                className=""
              >
                {data.professions.map((profession) => (
                  <option key={profession.id} value={profession.id}>
                    {profession.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="profile-data-edit">
            <div className="profile-data-title">Login-Daten</div>
            <div className="profile-data-items">
              <input 
                value={data.currentUser.email} 
                placeholder="E-mail"
                onChange={(e) => setEmail(e.target.value)}
              />

              <button 
                className="profile-data-password"
              >
                <a 
                  href={passwordResetUrl} 
                  className="profile-data-password"
                >
                  Jetzt Passwort ändern</a>
                </button>
              <button 
                className="profile-data-delete"
                onClick={onDeleteUser}
              >
                <img src={trashIcon} alt="delete" />
                <span>Konto löschen</span>
              </button>
            </div>
          </div>
          <button 
            className="profile-data-button"
            onClick={handleSubmit}
          >
            Änderungen speichern
          </button>
        </div>
      </div>
      <ModalPortal target={"modal-id"}>
        {showDelete && (
          <DeleteModal setShowDelete={setShowDelete} deleteUser={deleteUser} />
        )}
      </ModalPortal>
    </>
  );
};

export default ProfileEdit;
